import { PAGES } from '../lib/config';
import { PHOTO_FAQ } from '../lib/content';
import { ToolPageShell } from '../components/ToolPageShell';

export function EnlargePhotoOnlinePage() {
  const page = PAGES.find((p) => p.path === '/enlarge-photo-online')!;
  const extra = (
    <>
      <h2 className="text-2xl font-bold text-text-primary">Enlarge photos online</h2>
      <p>
        Make your photos larger directly in your browser. No software to install. Upload a photo,
        pick an upscale factor, and download the result.
      </p>
      <h3 className="text-xl font-semibold text-text-primary">Photo tips for best results</h3>
      <ul>
        <li>Use the original file, not a compressed copy</li>
        <li>Start with a clear, well-lit photo</li>
        <li>Do not crop too tightly before upscaling</li>
      </ul>
      <h3 className="text-xl font-semibold text-text-primary">Supported photo formats</h3>
      <p>JPG, PNG, and WebP are supported. Output matches the original format.</p>
    </>
  );
  return <ToolPageShell page={page} faqItems={PHOTO_FAQ} extraContent={extra} />;
}
